export interface ConfigNewResiduals {
  createdAt: Date;
  updatedAt: Date
  newResiduals: NewResiduals[];
}

export interface NewResiduals {
  year: number;
  residualPercentages: ResidualPercentage[];
}

export interface ResidualPercentage {
  modelNumber: string;
  termPercentages: TermPercentage[];
}

export interface TermPercentage {
  term: number;
  percentage: number;
}

export interface ConfigCertUsedResiduals {
  createdAt: Date;
  updatedAt: Date;
  residualValues: ResidualValue[];
}

export interface ResidualValue {
  modelNumber: string;
  year: number;
  values: TermValue[];
}

export interface TermValue {
  term: number;
  value: number;
}

export interface NewResidualInput {
  year: string;
  modelNumber: string;
  "24": string;
  "27": string;
  "30": string;
  "33": string;
  "36": string;
  "39": string;
  "42": string;
  "45": string;
  "48": string;
  "51": string;
  "54": string;
  "57": string;
  "60": string;
}

export interface CPOResidualInput {
  modelNum: string;
  year: string;
  "24mo": string;
  "36mo": string;
  "48mo": string;
  "60mo": string;
}

export interface ToyotaImporterResidualsOptions extends ToyotaImporterOptions {
  vehicleConditions?: VehicleCondition[]
}

export enum VehicleCondition {
  New = "new",
  UsedCertified = "usedcertified"
}

export interface ToyotaImporterIncentivesOptions extends ToyotaImporterOptions {
  clearSeriesModelMapping?: boolean
}

export interface ToyotaImporterOptions {
  vin?: string
}

// new residual input example
// model: "86 TRD SE"
// modelNumber: "6251"
// year: "2019"
// 24: "45"
// 36: "38"
// 48: "29"
// 60: "20"


// NEW RESIDUAL EXAMPLE
// {
//     "newResiduals": [
//         {
//             "year": 2020,
//             "residualPercentages": [
//                 {
//                     "modelNumber": "6252",
//                     "termPercentages": [
//                         {
//                             "term": 24,
//                             "percentage": 60
//                         },
//                         {
//                             "term": 27,
//                             "percentage": 57
//                         },
//                         {
//                             "term": 30,
//                             "percentage": 55
//                         },
//                         {
//                             "term": 33,
//                             "percentage": 53
//                         },
//                         {
//                             "term": 36,
//                             "percentage": 53
//                         },
//                         {
//                             "term": 39,
//                             "percentage": 49
//                         },
//                         {
//                             "term": 42,
//                             "percentage": 47
//                         },
//                         {
//                             "term": 45,
//                             "percentage": 45
//                         },
//                         {
//                             "term": 48,
//                             "percentage": 42
//                         },
//                         {
//                             "term": 51,
//                             "percentage": 40
//                         },
//                         {
//                             "term": 54,
//                             "percentage": 37
//                         },
//                         {
//                             "term": 57,
//                             "percentage": 35
//                         },
//                         {
//                             "term": 60,
//                             "percentage": 32
//                         }
//                     ]
//                 },
//             }
//     ]
// }
